const n="#ngc-input-currency-descriptor{visibility:hidden;display:none}";export{n as default};
